const ACCESORY_UNIT_INCOME = 'Accessory Unit Income';

export const AUTO_MOBILE_ALLOWANCE = 'Automobile Allowance';
export const ALIMONY = 'Alimony';
export const BOARDER_INCOME = 'Boarder Income';
export const CAPITAL_GAINS = 'Capital Gains';
export const CHILD_SUPPORT = 'Child Support';
export const DEFINED_CONTRIBUTION_PLAN = 'Defined Contribution Plan';
export const DISABILITY = 'Disability';
export const DIVIDENDS_INTEREST = 'Dividends Interest';
export const EMPLOYMENT_RELATED_ACCOUNT = 'Employment Related Account';
export const FOSTER_CARE = 'Foster Care';
export const HOUSING_ALLOWANCE = 'Housing Allowance';
export const HOUSING_CHOICE_PROGRAM = 'Housing Choice Voucher Program';
export const MORTGAGE_CREDIT_CERTIFICATE = 'Mortgage Credit Certificate';
export const MORTGAGE_DIFFERENTIAL = 'Mortgage Differential';
export const NON_BORROWER_HOUSEHOLD_INCOME = 'Non Borrower Household Income';
export const NOTES_RECEIVABLE_INSTALLMENT = 'Notes Receivable Installment';
export const PENSION = 'Pension';
export const PUBLIC_ASSISTANCE = 'Public Assistance';
export const ROYALTIES = 'Royalties';
export const RENTAL_INCOME = 'Rental Income';

export const SEPERATE_MAINTENANCE = 'Separate Maintenance';
export const SOCIAL_SECURITY = 'Social Security';
export const TEMPORARY_LEAVE = 'Temporary Leave';
export const TIP_INCOME = 'Tip Income';
export const UNEMPLOYED_BENEFITS = 'Unemployment Benefits';
export const VA_BENEFITS = 'VA Benefits NonEducational';
export const TRUST = 'Trust';
export const TRUST_INCOME = 'Trust Income';
export const RETIREMENT = 'Retirement(IRA, 401K, Annuities)';
export const OVERTIME = 'Overtime';
export const BONUS = 'Bonus';
export const COMMISSIONS = 'Commissions';
export const OTHER = 'Other';

export const otherIncomesRSNT = [
  { label: 'Select Source ', value: '' },
  { label: ALIMONY, value: ALIMONY },
  { label: CAPITAL_GAINS, value: CAPITAL_GAINS },
  { label: CHILD_SUPPORT, value: CHILD_SUPPORT },
  { label: DISABILITY, value: DISABILITY },
  { label: DIVIDENDS_INTEREST, value: DIVIDENDS_INTEREST },
  { label: PENSION, value: PENSION },
  { label: ROYALTIES, value: ROYALTIES },
  { label: RENTAL_INCOME, value: RENTAL_INCOME },
  { label: SOCIAL_SECURITY, value: SOCIAL_SECURITY },
  { label: TIP_INCOME, value: TIP_INCOME },
  {
    label: VA_BENEFITS,
    value: VA_BENEFITS,
  },
  { label: RETIREMENT, value: RETIREMENT },
  { label: BONUS, value: BONUS },
  { label: OVERTIME, value: OVERTIME },
  { label: COMMISSIONS, value: COMMISSIONS },
  { label: TRUST_INCOME, value: TRUST_INCOME },
  { label: OTHER, value: OTHER },
];

export const otherIncomes = [
  { label: 'Select Source ', value: '' },
  { label: ACCESORY_UNIT_INCOME, value: ACCESORY_UNIT_INCOME },
  { label: ALIMONY, value: ALIMONY },
  { label: AUTO_MOBILE_ALLOWANCE, value: AUTO_MOBILE_ALLOWANCE },
  { label: BOARDER_INCOME, value: BOARDER_INCOME },
  { label: CAPITAL_GAINS, value: CAPITAL_GAINS },
  { label: CHILD_SUPPORT, value: CHILD_SUPPORT },
  {
    label: DEFINED_CONTRIBUTION_PLAN,
    value: DEFINED_CONTRIBUTION_PLAN,
  },
  { label: DISABILITY, value: DISABILITY },
  { label: DIVIDENDS_INTEREST, value: DIVIDENDS_INTEREST },
  {
    label: EMPLOYMENT_RELATED_ACCOUNT,
    value: EMPLOYMENT_RELATED_ACCOUNT,
  },
  { label: FOSTER_CARE, value: FOSTER_CARE },
  { label: HOUSING_ALLOWANCE, value: HOUSING_ALLOWANCE },
  {
    label: HOUSING_CHOICE_PROGRAM,
    value: HOUSING_CHOICE_PROGRAM,
  },
  {
    label: MORTGAGE_CREDIT_CERTIFICATE,
    value: MORTGAGE_CREDIT_CERTIFICATE,
  },
  {
    label: MORTGAGE_DIFFERENTIAL,
    value: MORTGAGE_DIFFERENTIAL,
  },
  {
    label: NON_BORROWER_HOUSEHOLD_INCOME,
    value: NON_BORROWER_HOUSEHOLD_INCOME,
  },
  {
    label: NOTES_RECEIVABLE_INSTALLMENT,
    value: NOTES_RECEIVABLE_INSTALLMENT,
  },
  { label: PENSION, value: PENSION },
  { label: PUBLIC_ASSISTANCE, value: PUBLIC_ASSISTANCE },
  { label: ROYALTIES, value: ROYALTIES },
  { label: RENTAL_INCOME, value: RENTAL_INCOME },
  { label: SEPERATE_MAINTENANCE, value: SEPERATE_MAINTENANCE },
  { label: SOCIAL_SECURITY, value: SOCIAL_SECURITY },
  { label: TEMPORARY_LEAVE, value: TEMPORARY_LEAVE },
  { label: TIP_INCOME, value: TIP_INCOME },
  { label: TRUST, value: TRUST },
  { label: UNEMPLOYED_BENEFITS, value: UNEMPLOYED_BENEFITS },
  {
    label: VA_BENEFITS,
    value: VA_BENEFITS,
  },
  { label: OTHER, value: OTHER },
];

export const otherIncomesCardType = [
  { label: 'Select Source ', value: '' },
  { label: ALIMONY, value: ALIMONY },
  { label: CHILD_SUPPORT, value: CHILD_SUPPORT },
  { label: DISABILITY, value: DISABILITY },
  { label: FOSTER_CARE, value: FOSTER_CARE },
  { label: HOUSING_ALLOWANCE, value: HOUSING_ALLOWANCE },
  { label: PENSION, value: PENSION },
  { label: RENTAL_INCOME, value: RENTAL_INCOME },
  { label: ROYALTIES, value: ROYALTIES },
  { label: SOCIAL_SECURITY, value: SOCIAL_SECURITY },
  { label: TRUST, value: TRUST },
  { label: OTHER, value: OTHER },
];
